import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppConfigService } from '../../../../services/app-config.service';
import { AuthService } from '../../../../services/auth.service';
import { StateService } from '../../../../services/state.service';

import * as _ from 'lodash';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {
    public loading: boolean;

    public authUserScope: string;
    public allowedModules: any;

    public publicUse: boolean;

    constructor(
        private route: ActivatedRoute,
        private appConfigService: AppConfigService,
        private authService: AuthService,
        public stateService: StateService
    ) {
        this.loading = true;
    }

    ngOnInit() {
        const environment = this.appConfigService.config.environment;

        setTimeout(async () => {
            this.stateService.state.hasMenu = true;

            // Set menu allowedModules by user.permissions.mudules
            if (this.authService.userProfile) {
                this.allowedModules = this.authService.userProfile.permissions.modules;
                this.authUserScope = this.authService.userProfile.permissions.scope;
            }

            // Disable public use before publish date 3.6.2019
            // Disable public use on prod environment before publish date 3.6.2019
            this.publicUse = true;
            if (environment === 'prod' && new Date() < new Date('2019-06-03 00:00:00.000Z')) {
                this.publicUse = false;
            }

            this.loading = false;
        });
    }

}
